export const getAssetFileFullPath = (path?: string) => {
    if (path?.startsWith('http')) {
        return path;
    }
    return path ? `/configuration/assets/${path}` : undefined;
};
